import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import type { Locale } from '../../server/src/shared/locale';
import { $locale } from '../state/locale';
import { messages, type Messages } from './messages';

export const getMessages = (locale: Locale): Messages =>
  messages[locale] ?? messages.en;

export const formatMessage = (
  template: string,
  params: Record<string, string | number>
): string =>
  Object.entries(params).reduce(
    (result, [key, value]) =>
      result.replaceAll(`{${key}}`, String(value)),
    template
  );

export const useI18n = (): Messages => {
  const locale = useUnit($locale);
  return useMemo(() => getMessages(locale), [locale]);
};
